import { Info } from 'lucide-react';
import { useTour } from '../contexts/TourContext';
import { IconButton, Tooltip } from '@mui/material';

export function TourButton() {
  const { startTour } = useTour();

  return (
    <Tooltip title="Start Tour">
      <IconButton
        data-tour="tour-button"
        onClick={startTour}
        sx={{
          color: 'white',
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
          },
        }}
        aria-label="Start application tour"
      >
        <Info className="size-5" />
      </IconButton>
    </Tooltip>
  );
}